var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('js-object-view-item',{attrs:{"maxDepth":_vm.maxDepth,"data":_vm.parsed,"styles":_vm.customStyles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }